import { render } from "./Asistentes.vue?vue&type=template&id=45a8fea4"
import script from "./Asistentes.vue?vue&type=script&lang=js"
export * from "./Asistentes.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice-base-vue3/backoffice-base-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__